import { api } from '../commonApi';
import { IAiChatMessage, ISendAiChatMessageRequest } from '../../proto/aiChat/aiChat';

export const BASE_CHAT_URL = `/chat`;

export const chatApi = api.injectEndpoints({
	endpoints: (builder) => ({
		sendMessage: builder.mutation<IAiChatMessage, ISendAiChatMessageRequest>({
			query: (body) => ({
				url: `${BASE_CHAT_URL}`,
				method: 'POST',
				body,
			}),
		}),
	}),
});

export const { useSendMessageMutation } = chatApi;
